/**
 * Поддерживает ли учтройство тач
 * @returns {boolean|number}
 */
export function isTouchDevice () {
  if (process.env.BROWSER) {
    return 'ontouchstart' in window || navigator.msMaxTouchPoints;
  }

  return false;
}

/**
 * Добавляет класс className к DOM-элементу с идентификатором id
 * @param id
 * @param className
 */
export function addClassById (id, className) {
  const el = document.getElementById(id);
  if (!el) {
    return;
  }

  addClass(el, className);
}

export function addClass (elNode, className) {
  const arr = elNode.className.split(' ');

  if (arr.indexOf(className) === -1) {
    elNode.className = (elNode.className + ' ' + className).trim();
  }
}

/**
 * Удаляет класс className у DOM-элемента с идентификатором id
 * @param id
 * @param className
 */
export function removeClassById (id, className) {
  const el = document.getElementById(id);
  if (!el) {
    return;
  }

  removeClass(el, className);
}

export function removeClass (elNode, className) {
  const arr = elNode.className.split(' ');

  if (arr.indexOf(className) !== -1) {
    elNode.className = elNode.className.replace(className, '').trim();
  }
}



// WEBPACK FOOTER //
// ./src/utils/browser.js